<template>
	<div class="widget__search">
		<input
			type="text"
			class="field"
			id="file-search"
			v-model="search"
			placeholder="Search"
			@input="emitChange"
		/>
	</div>
</template>

<script>
export default {
	data() {
		return {
			search: '',
		};
	},

	methods: {
		emitChange(event) {
			this.search = event.target.value;
			this.$emit('search-change', this.search);
		},
	},
};
</script>

<style scoped>
	.widget__search { flex: 0 1 80%; }
</style>
